import { Divider } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { ApiAdapter } from "../../utils/adapters";
import { useDB } from "../../utils/custom_hooks/UseDB";
import { pageListeners } from "../../utils/listeners";
import { GoalHistoriesHandler } from "../../utils/state_handlers";
import { GoalHistoryTable } from "./GoalHistoryTable";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import { GoalHistoryContainer } from "./GoalHistoryContainer";
import { GoalHistoryBlock } from "../../goal_templates/classes/goal_history_block_class";

const HistoriesIndex = ({ patient_id }) => {
  const [DBObject, setDBObject] = useDB({ patientId: patient_id });
  var newApi = new ApiAdapter();
  const [api] = useState(newApi);
  const [status, setStatus] = useState({
    isActive: false,
    isLoaded: false,
    loadFail: false,
    dataLoaded: false,
  });
  const [t, i18n] = useTranslation();
  const [historyPayload, setHistoryPayload] = useState();

  useEffect(() => {
    pageListeners.detectActiveGoalHistoryTab(status, setStatus);
  }, []);

  useEffect(() => {
    console.log("active status is:", status.isActive);
    status.isActive ? setStatus({ ...status, isLoaded: true }) : null;
  }, [status.isActive]);

  useEffect(() => {
    if (status.isLoaded) {
      GoalHistoryBlock.clear();
      api
        .retrieveGoalHistories(patient_id)
        .then((payload) => {
          setDBObject({ indexTableHeaders: payload.headers });
          new GoalHistoriesHandler(payload.payload, setHistoryPayload);
        })
        .finally(() => {
          setStatus({ ...status, dataLoaded: true });
        })
        .catch(() => setStatus({ ...status, loadFail: true }));
    }
  }, [status.isLoaded]);

  const statusMessage = () => {
    if (!status.isLoaded) return null;
    if (!status.dataLoaded)
      return t("views.goals.errors.loading_goal_histories_notice");
    if (status.loadFail)
      return t("views.goals.errors.goal_histories_load_failure");
  };

  return status.dataLoaded && status.isActive && !status.loadFail ? (
    <div className="goal-history-wrapper">
      <GoalHistoryContainer DBObject={DBObject} uuid={uuidv4} t={t} />
    </div>
  ) : (
    <div>{statusMessage()}</div>
  );
};

export default HistoriesIndex;
